module.exports = __webpack_public_path__ + "static/media/rps3.b5f4c905.png";